{
  "label": "device",
  "name": "Name",
  "model": "Model",
  "type": "Type",
  "serialNumber": "Serial number",
  "sector": "Sector",
  "connectivity": "Connectivity",
  "certificate": "Certificate",
  "state": "State",
  "states": {
    "activated": "Activated",
    "deactivated": "Deactivated",
    "registered": "New"
  },
  "actions": {
    "scheduled": {
      "title": "Actions in progress?",
      "yes": "Yes",
      "no": "No",
      "error": "Undefined"
    }
  },
  "firmwareVersion": "Firmware version",
  "hardwareVersion": "Hardware version",
  "updateCertificate": "Update certificate",
  "updateFirmware": "Update firmware",
  "updateState": {
    "activate": {
      "title": "Activate",
      "execute": "Activate device",
      "description": "Device {name} will be activated."
    },
    "deactivate": {
      "title": "Deactivate",
      "execute": "Deactivate device",
      "description": "Device {name} will be deactivated.",
      "warning": "A deactivated device does no longer benefits of automatic and manual certificate updates.",
      "error": "This device cannot be deactivated because it has an operation scheduled or running."
    }
  },
  "month": "{n} month | {n} months",
  "year": "{n} year | {n} years",
  "custom": "Custom",
  "dateFormat": "YYYY/MM/DD hh:mm A",
  "empty": "No device found",
  "delete": {
    "execute": "Delete device",
    "description": "Device {name} will be deleted.",
    "warning": "The operations associated with the device will also be deleted.",
    "error": "This device cannot be deleted because it has an operation scheduled or running."
  },
  "description": {
    "title": "Description",
    "idCard": "Id card",
    "state": "State",
    "connectivity": "Connectivity",
    "lastConnection": "Last connection",
    "certificateValidityDate": "Certificate validity date",
    "lastChange": "Last change",
    "configurationApplicationDate": "Configuration application date",
    "lastRebootDate": "Last reboot Date",
    "firstCommissioningDate": "Date of the first commissioning",
    "lastFirmwareUpdate": "Last firmware update",
    "mobileNetwork": "Mobile network",
    "gsmFrequencyBand": "GSM frequency band",
    "communicationProtocol": "Communication protocol"
  },
  "certificateForm": {
    "expirationDate": "Certificate expiration date",
    "certificateOrigin": "Origin of the certificate",
    "lastUpdate": "Last update of the certificate"
  },
  "firmwareForm": {
    "title": "Firmware",
    "version": "Version",
    "description": "Firmware description",
    "origin": "Origin of the firmware",
    "lastUpdate": "Last update"
  },
  "configurationForm": {
    "title": "Configuration"
  },
  "operation": {
    "cancel": {
      "tooltip": {
        "enabled": "Cancel operation",
        "disabled": "You cannot cancel the operation"
      },
      "confirm": {
        "title": "Cancelling the operation",
        "description": "This operation will be cancelled. Cancellation cannot be undone."
      }
    },
    "unitary": "Unitary",
    "campaign": "Campaign",
    "update": {
      "tooltip": {
        "enabled": "Update operation",
        "disabled": "You cannot update the operation"
      }
    }
  },
  "additionalMetadata": {
    "title": "Additional metadata",
    "options": {
      "title": "Options",
      "software": {
        "1": "Process control",
        "2": "Pumping stations",
        "3": "WEB Server",
        "4": "Website Mimic Diagram",
        "5": "IP backup ADSL / GSM",
        "6": "IEC60870-5-104 Slave"
      },
      "numericSoftware": {
        "1": "Number of data points: {value}",
        "2": "Number of I/O modules: {value}",
        "3": "Number of COM modules: {value}"
      }
    },
    "communicationModules": {
      "title": "Communication modules"
    },
    "modulesIo": {
      "title": "Modules I/O"
    },
    "modules": {
      "location": "Position",
      "module": "Module"
    }
  },
  "warningMessage": "The device already have an operation of the same type scheduled or running"
}
